
import {onFind} from "@elements/init-modules-in-scope";
import {find,findIn, findAllIn, closest, on, addClass, removeClass, trigger} from '@elements/dom-utils';
import asyncAppend from "@elements/async-append";
import axios from "axios";
import Modal from 'bootstrap/js/dist/modal';
import * as formValidation from '@elements/form-validation';
import {scrollTop} from "./ajax-form-extend";
import {loadGoogleMapsAPI} from "./google-map-package";

const selectors = {
    base: '.js-check-email',
    checkEmailForm: '.js-check-email__form',
    checkEmailBtn: '.js-check-email__btn',
    checkEmailInput: '.js-check-email__input',
    target: '.js-check-email__result',
    loading: '.js-check-email__loading',
};

export function init () {
    onFind(selectors.base, function (baseElement) {
        let checkEmailForm = find(selectors.checkEmailForm);

        onFind(selectors.checkEmailBtn, function (checkEmailBtn) {
            if(checkEmailBtn){
                on('click', function (evt) {
                    evt.preventDefault();
                    formValidation.getApi(checkEmailForm).then((formApi) => {
                        let formInstance = formApi.getFormInstance();
                        formInstance.validate().then((state) => {
                            if (state === 'Valid' ) {
                                console.log('valid')
                                let checkEmailUrl = baseElement.dataset.checkEmailUrl;
                                if (checkEmailUrl) {
                                    let email = findIn(selectors.checkEmailInput, baseElement);
                                    let data = {
                                        email: email.value,
                                    };

                                    loadContent(baseElement, checkEmailUrl, data, 'POST').then(function (res) {
                                        if(!res.data.content["email-result"] && !res.data.content["email-prescriber-result"]){
                                            let dataAction = checkEmailForm.getAttribute('data-action');
                                            checkEmailForm.setAttribute('action', dataAction);
                                            checkEmailForm.submit();
                                        }
                                    });
                                }
                            }
                        });
                    });
                    scrollTop(checkEmailForm);
                }, checkEmailBtn)
            }
        });
    });
}

export     function loadContent(baseElement, url, data, method, showLoadingOverlay = true) {
    let pendingRequest = null;
    if (method === 'GET') {
        pendingRequest = axios({method: 'GET', url: url, params: data});
    } else {
        pendingRequest = axios({method: 'POST', url: url, data: data});
    }

    let results = findAllIn(selectors.target, baseElement);
    let targetsByResultId = {};

    results.forEach((element) => {
        let resultId = element.dataset.checkEmailResultId || 'default';
        if (targetsByResultId[resultId]) {
            targetsByResultId[resultId] = [...targetsByResultId[resultId], element];
        } else {
            targetsByResultId[resultId] = [element];
        }
    });

    if(showLoadingOverlay){
        asyncAppend({
            target: targetsByResultId,
            loading: findAllIn(selectors.loading, baseElement),
            options: {
                allowScriptTags: true
            }
        }, pendingRequest.then((x) => x.data));
    }else{
        asyncAppend({
            target: targetsByResultId,
            options: {
                allowScriptTags: true
            }
        }, pendingRequest.then((x) => x.data));
    }


    return pendingRequest;
}

